var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "standard-image-display",
    {
      attrs: {
        "file-store": _vm.fileStore,
        aspect: _vm.aspect,
        "object-position": _vm.objectPosition,
        "object-fit": _vm.objectFit,
        "lazy-loading": "lazy",
        "image-tint-strength": parseInt(_vm.imageTintStrength),
      },
    },
    [
      _c(
        "template",
        { slot: "image-content-layer" },
        [
          _vm._t("image-content-layer", null, {
            component: "wrapperComponent",
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.overlayAttribution && _vm.displayAttribution
        ? _c(
            "div",
            {
              staticClass: "image-attribution-overlay",
              class: _vm.toggleAttribution.class,
              attrs: { slot: "image-attribution-overlay" },
              slot: "image-attribution-overlay",
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.imageInfoToggle
                    ? _c("ContentImageInfo", {
                        attrs: {
                          "author-name": _vm.authorName,
                          "author-description": _vm.authorDescription,
                          "author-url": _vm.authorUrl,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "action",
                  attrs: {
                    title: `${_vm.toggleAttribution.text} Image Attribution`,
                    alt: "Image Attribution",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggle()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        x: "0px",
                        y: "0px",
                        viewBox: "0 0 100 100",
                        "xml:space": "preserve",
                      },
                    },
                    [
                      _c("g", [
                        _c("circle", {
                          attrs: { cx: "50", cy: "54.1", r: "12.9" },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M91.5,28.9l-20.8-2.5l-4.4-8.9c-0.8-1.7-2.5-2.7-4.4-2.7H38.1c-1.9,0-3.6,1.1-4.4,2.7l-4.4,8.9L8.5,28.9     c-3.4,0.4-6,3.3-6,6.8v38c0,3.8,3.1,6.9,6.9,6.9h24.1c4.8,3,10.4,4.8,16.5,4.8c6.1,0,11.7-1.8,16.5-4.8h24.1     c3.8,0,6.9-3.1,6.9-6.9v-38C97.5,32.2,94.9,29.3,91.5,28.9z M21.4,44c0,1.6-1.3,2.9-2.9,2.9h-4.2c-1.6,0-2.9-1.3-2.9-2.9v-4.2     c0-1.6,1.3-2.9,2.9-2.9h4.2c1.6,0,2.9,1.3,2.9,2.9V44z M50,73.7c-10.8,0-19.6-8.8-19.6-19.6c0-10.8,8.8-19.6,19.6-19.6     c10.8,0,19.6,8.8,19.6,19.6C69.6,64.9,60.8,73.7,50,73.7z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.overlayAttribution && _vm.displayAttribution
        ? _c(
            "div",
            {
              staticClass: "image-attribution-footer",
              attrs: { slot: "image-attribution-footer" },
              slot: "image-attribution-footer",
            },
            [
              _c("ContentImageInfo", {
                attrs: {
                  "author-name": _vm.authorName,
                  "author-url": _vm.authorUrl,
                  "author-description": _vm.authorDescription,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }